import { zodResolver } from "@hookform/resolvers/zod";
import React from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { Button } from "../../components/ui/button";
import {
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "../../components/ui/form";
import { Textarea } from "../../components/ui/textarea";

const formSchema = z.object({
  cancelReason: z
    .string()
    .min(10, {
      message: "Note must be at least 10 characters.",
    })
    .max(500, {
      message: "Note must not be longer than 500 characters.",
    }),
});

const CancelAppointmentDialog = ({
  onSubmit,
  type = "note",
  title = "Add Note",
  setIsCancelDialogOpen,
}) => {
  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      cancelReason: "",
    },
  });

  const handleSubmit = (data) => {
    onSubmit(data);
    form.reset();
  };

  const getButtonText = () => {
    if (type === "cancel") {
      return {
        submit: "Cancel Appointment",
        variant: "destructive",
      };
    }
    return {
      submit: "Add Note",
      variant: "primary",
    };
  };

  const buttonConfig = getButtonText();

  return (
    <DialogContent className="sm:max-w-[500px]">
      <DialogHeader>
        <DialogTitle>{title}</DialogTitle>
      </DialogHeader>

      <Form {...form}>
        <form onSubmit={form.handleSubmit(handleSubmit)} className="space-y-4">
          <FormField
            control={form.control}
            name="cancelReason"
            render={({ field }) => (
              <FormItem>
                <FormLabel>
                  {type === "cancel" ? "Cancellation Reason" : "Note"}
                </FormLabel>
                <FormControl>
                  <Textarea
                    placeholder={
                      type === "cancel"
                        ? "Please provide a reason for cancelling this appointment..."
                        : "Add your note here..."
                    }
                    className="min-h-[100px]"
                    {...field}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <DialogFooter className="gap-2">
            <Button
              type="button"
              variant="outline"
              onClick={setIsCancelDialogOpen}
            >
              Cancel
            </Button>
            <Button type="submit" variant={buttonConfig.variant}>
              {buttonConfig.submit}
            </Button>
          </DialogFooter>
        </form>
      </Form>
    </DialogContent>
  );
};

export default CancelAppointmentDialog;
